export const environment = {
  production: false,
  projectConfiguration: {
    name: "POLIPUSH_TEST",
    API_URL: "https://polipush.test.api.testctsolution.it/api"
  },
  keys: {
    TinyMCE: "boqg39ohpzcc8jme5jt2focybafrja1frizyfdnt53fa7i6w"
  },
  // Configurazione Business Intelligence
  biDomain: "https://bi.polipush.it",
  // NUOVO: Configurazione tema
  brand: {
    type: 'polipush',
    name: 'Polipush',
    theme: {
      primaryColor: '#3244b0',
      secondaryColor: '#0087fd',
      bgColor: '#01003d',
      logo: 'assets/images/logo/logo.svg',
      favicon: 'favicon.ico',
      loginBackground: 'assets/images/background/polipush-3D.jpg',
      extendedLogo: 'assets/images/logo/logo-extended.png'
    },
    ref: 'https://polipush.it'
  }
};